import React from 'react'
import { StyledIcon } from '../StyledIcon'

const CustomSettingIcon = ({ icon, size, customProps }) => (
  <StyledIcon
    viewBox="0 0 514.135 514.135"
    a11yTitle={icon}
    size={size}
    color="plain"
    {...customProps}
  >
    <g>
      <path
        d="M410.684,308.268c-10.24,0-17.92,2.56-25.6,2.56l-74.24-74.24l61.44-61.44l79.36-28.16l58.88-94.72
  c2.56-5.12,2.56-12.8,0-15.36l-30.72-30.72c-5.12-5.12-12.8-5.12-17.92-2.56l-97.28,56.32l-30.72,81.92l-61.44,61.44l-69.12-74.24
  c0-7.68,2.56-15.36,2.56-25.6c0-66.56-64-115.2-128-99.84l38.4,38.4c20.48,20.48,20.48,51.2,0,71.68
  c-20.48,20.48-51.2,20.48-71.68,0l-40.96-35.84c-20.48,74.24,48.64,145.92,125.44,122.88l74.24,74.24l-30.72,30.72
  c-17.92-5.12-35.84,0-48.64,12.8l-104.96,104.96c-20.48,20.48-23.04,51.2-5.12,71.68c20.48,23.04,53.76,23.04,74.24,2.56
  l107.52-107.52c12.8-12.8,17.92-33.28,12.8-48.64l30.72-30.72l74.24,74.24c-2.56,7.68-2.56,17.92-2.56,25.6
  c0,66.56,64,115.2,128,99.84l-38.4-38.4c-20.48-20.48-20.48-51.2,0-71.68c20.48-20.48,51.2-20.48,71.68,0l38.4,38.4
  C528.444,372.268,477.244,308.268,410.684,308.268z"
      />
    </g>
  </StyledIcon>
)

export default CustomSettingIcon
